import React from 'react';

function StatsSection() {
  return (
    <div className="stats-section">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-3 col-6">
            <div className="stat-item">
              <i className="fas fa-star-half-alt stat-icon"></i>
              <div className="stat-number">8349+</div>
              <div className="stat-label">Reviews</div>
            </div>
          </div>
          <div className="col-md-3 col-6">
            <div className="stat-item">
              <i className="fas fa-users stat-icon"></i>
              <div className="stat-number">56541+</div>
              <div className="stat-label">Satisfied Travelers</div>
            </div>
          </div>
          <div className="col-md-3 col-6">
            <div className="stat-item">
              <i className="fas fa-map-marked-alt stat-icon"></i>
              <div className="stat-number">50+</div>
              <div className="stat-label">Destinations</div>
            </div>
          </div>
          <div className="col-md-3 col-6">
            <div className="stat-item">
              <i className="fas fa-briefcase stat-icon"></i>
              <div className="stat-number">8 Years+</div>
              <div className="stat-label">Experience</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default StatsSection;